/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userCampaignMessages.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class AddressDataModel(
    @SerialName("street")
    val street: String?,

    @SerialName("city")
    val city: String?,

    @SerialName("region")
    val region: String?,

    @SerialName("country")
    val country: String?,

    @SerialName("country_code")
    val countryCode: String?,

    @SerialName("formatted")
    val formatted: String?,

    @SerialName("lat")
    val lat: Double?,

    @SerialName("long")
    val long: Double?,

    @SerialName("zip_code")
    val zipCode: String?,

    @SerialName("unit")
    val unit: String?,

    @SerialName("address")
    val address: String?
) : Model()
